import React, { useContext } from "react";
import loadable from "@loadable/component";
import clsx from "clsx";
import PageContext from "@PageContext";

import styles from "./Breadcrumb.styles";

const Container = loadable(() => import("@Components/views/Container"));
const ReactBreadcrumb = loadable(() =>
	import("@micado-digital/react-breadcrumb/ReactBreadcrumb")
);
const ReactSVGIcon = loadable(() => import("@micado-digital/react-svg-icon/ReactSVGIcon"));

const Breadcrumb = () => {
	const [pageData] = useContext(PageContext);
	const { breadcrumbs = [] } = pageData;
	const css = styles();

	return (
		<div className={clsx(css.breadcrumb, "mco-view-component-breadcrumb")}>
			<Container>
				<ReactBreadcrumb
					data={breadcrumbs}
					homeIcon={
						<ReactSVGIcon className={css.homeIcon} size={16} src="/img/icons/home.svg" />
					}
					homeLabel="Home"
					homeLink="/"
					separator={<span className={css.separator}></span>}
				/>
			</Container>
		</div>
	);
};

export default Breadcrumb;
